import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Spinner } from 'react-bootstrap';
import {Link} from "react-router-dom";
import Header from '../components/Header';

const AllStats = () => {
    const [stats, setStats] = useState(null);

    useEffect(() => {
        fetch('https://ems.lexikonn.eu/api/get_stats.php')
            .then(res => res.json())
            .then(data => setStats(data));
    }, []);

    if (!stats) return <div className="text-center py-5"><Spinner animation="border" /></div>;

    return (
        <div className="container py-5">
            <Link to="/" className="btn btn-secondary mb-3">Zpět</Link>
            <Header/>
            <h2 className="mb-4">📊 Statistiky EMS výjezdů</h2>

            <Row className="mb-4">
                <Col md={4}>
                    <Card className="text-center my-1 bg-light">
                        <Card.Body>
                            <Card.Title>Dnes</Card.Title>
                            <Card.Text className="display-6">{stats.today}</Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="text-center my-1 bg-light">
                        <Card.Body>
                            <Card.Title>Tento týden</Card.Title>
                            <Card.Text className="display-6">{stats.week}</Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="text-center my-1 bg-light">
                        <Card.Body>
                            <Card.Title>Tento měsíc</Card.Title>
                            <Card.Text className="display-6">{stats.month}</Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row>
                <Col md={6}>
                    <Card className="my-1">
                        <Card.Header>🏅 Nejlepší záchranáři (celkově)</Card.Header>
                        <Card.Body>
                            <ol>
                                {stats.top_all.map((item, index) => (
                                    <li key={index}><b>{item.user}</b> — {item.count} {(item.count == 1) ? <>výjezd</> : (item.count >= 2 && item.count < 5) ? <>výjezdy</> : <>výjezdů</>}</li>
                                ))}
                            </ol>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card className="my-1">
                        <Card.Header>🏆 Nejlepší za poslední měsíc</Card.Header>
                        <Card.Body>
                            <ol>
                                {stats.top_month.map((item, index) => (
                                    <li key={index}><b>{item.user}</b> — {item.count} {(item.count == 1) ? <>výjezd</> : (item.count >= 2 && item.count < 5) ? <>výjezdy</> : <>výjezdů</>}</li>
                                ))}
                            </ol>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default AllStats;